module.exports = __webpack_public_path__ + "static/media/categories.8ae4a1eb.svg";